import { getValueFromUserPref } from './user-pref-cookie-service';

export const normalizeLocationName = (value: string | undefined | null): string =>
    (value ?? '').trim().toLowerCase();

export const isSameLocationName = (
    a: string | undefined | null,
    b: string | undefined | null
): boolean => normalizeLocationName(a) === normalizeLocationName(b);

/**
 * The page's current location from hydrated client data, falling back to gt_userPref.
 */
export const getPageLocationFromClient = (): string | undefined => {
    if (typeof window === 'undefined') {
        return undefined;
    }

    const fromClientData = (
        window as { clientData?: { searchBar?: { location?: { value?: string } } } }
    ).clientData?.searchBar?.location?.value;

    if (fromClientData?.trim()) {
        return fromClientData;
    }

    return getValueFromUserPref('location');
};

/**
 * True when the submitted location differs from the page location (case-insensitive).
 * When page location is empty, treat as changed so first-time selection still persists.
 */
export const hasLocationChangedFromPage = (
    inputLocation: string,
    pageLocation?: string | null
): boolean => {
    const resolvedPageLocation = pageLocation ?? getPageLocationFromClient();

    if (!resolvedPageLocation?.trim()) {
        return true;
    }

    return !isSameLocationName(inputLocation, resolvedPageLocation);
};

export const shouldPersistLocationSelection = (
    inputLocation: string,
    pageLocation?: string | null
): boolean => hasLocationChangedFromPage(inputLocation, pageLocation);
